import { render } from "./giveReturnModel.vue?vue&type=template&id=05207c06"
import script from "./giveReturnModel.vue?vue&type=script&lang=js"
export * from "./giveReturnModel.vue?vue&type=script&lang=js"

import "./giveReturnModel.vue?vue&type=style&index=0&id=05207c06&lang=scss"

import exportComponent from "D:\\companyProject\\G10Product\\trunk\\Bestech.CloudPos\\Bestech.CloudPos.Portal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__